import React, { Component } from "react";
import { Container, } from "reactstrap";
import { NavLink } from "react-router-dom";

class MainPage extends Component {
    constructor(props) {
        super(props)
        this.getCurrentLink = this.getCurrentLink.bind(this)
    }

    componentDidMount() {
        this.getCurrentLink();
    }

    getCurrentLink() {
        //  get current page through the route
        const subDirectories = ["hebergement", "vols", "visas", "voyages", "cars", "divertissements"]
        for (let i = 0; i < subDirectories.length; i++) {
            const elm = subDirectories[i];
            const currentLink = window.location.href
            const subPath = currentLink.search(elm)
            if (subPath > 0) {
                document.getElementById(elm).classList.add('active2')
            }
        }
    }

    render() {
       return(
        <section className='navigation2 text-center d-none d-md-block pb-3'>
          <Container>
            <ul className='list-unstyled list-inline border-bottom m-0' >
            <NavLink to='/hebergement' className='text-uppercase '>
              <li  id="hebergement" className='list-inline-item px-4 py-3' >
                  Hebergements
              </li>
              </NavLink>

              <NavLink to='/vols' className='text-uppercase' >
              <li id="vols" className='list-inline-item px-4 py-3'>
                  Vols
              </li>
              </NavLink>

              <NavLink to='/visas' className='text-uppercase '>
              <li id="visas" className='list-inline-item px-4 py-3'>
                  Visa
              </li>
              </NavLink>

              <NavLink to='/voyages' className='text-uppercase'>
              <li id="voyages" className='list-inline-item px-4 py-3'>
                  voyages
              </li>
              </NavLink>
              <li id="cars" className='list-inline-item px-4 py-3'>
                <NavLink to='/cars' className='text-uppercase'>
                  véhicule
                </NavLink>
              </li>

              <NavLink to='/divertissements' className='text-uppercase'>
              <li id="divertissements" className='list-inline-item px-4 py-3'>
                  divertissements
              </li>
              </NavLink>

            </ul>
            {/* {!this.props.under &&(<hr />)} */}
            
          </Container>
        </section>
        
      
       );
    }
}

export default MainPage;